<section class="carousel" aria-label="Gallery" *transloco="let t">
  <aside class="navigation">
    @if (appearance === 'collections') {
      <h3>
        <em>{{ t('Our') }}</em> {{ t('top collections') }}
      </h3>
    }
    @if (childrenCount() > 1) {
      <ol class="navigation-list">
        @for (child of children(); track child; let i = $index) {
          <li class="navigation-item">
            <button
              app-button
              class="navigation-button"
              (click)="goTo(i)"
              (animationend)="onNext()"
              [class.showed]="i < activeItemIndex()"
              [class.active]="i === activeItemIndex()"
            >
              <span style="position: relative; z-index: 10"> {{ child.label }} </span>
              <svg>
                <circle
                  class="progress-circle"
                  cx="15"
                  cy="15"
                  r="12"
                  stroke-width="1"
                  fill="transparent"
                  [attr.stroke]="color()"
                />
              </svg>
            </button>
          </li>
        }
      </ol>
    }
  </aside>

  <ol #viewport class="viewport">
    <ng-content />
  </ol>
  @if (!isStartPosition()) {
    <button
      app-button="icon-button"
      class="prev"
      (click)="onPrev()"
      [class.is-hidden]="isStartPosition()"
      [title]="'Move to previous item'"
    >
      <svg-icon key="navigation-left" fontSize="8" [color]="color()"></svg-icon>
    </button>
  }
  @if (!isEndPosition() && children().length > 1) {
    <button
      app-button="icon-button"
      class="next"
      (click)="onNext()"
      [class.is-hidden]="isEndPosition()"
      [title]="t('Move to next item')"
    >
      <svg-icon key="navigation-right" fontSize="8" [color]="color()"></svg-icon>
    </button>
  }

  <div class="visual-scrollbar">
    <div
      class="visual-scrollbar-thumb"
      [style.transform]="'translateX(' + thumbTranslate() + ')'"
      [style.width.%]="thumbWidthPercentage()"
    ></div>
  </div>
</section>
